import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import EventAdd from "./EventAdd";

const EventAddPage = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <EventAdd />
      </CardBackground>
    </MainTemplate>
  );
};

export default EventAddPage;
